// Func = limiting Scope for this file
(function(){

	function resizeWindow(){

	}
	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	}

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});


		
		//Open Navigation
		$('#menu-btn').click(function(event) {
			$('#menu-btn').toggleClass('btn-active');
			$('#primary-nav').toggleClass('nav-visible');
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

		function bookingDates(){
			let getCheckInValue = document.getElementById('CheckIn').value;
			let getCheckOutValue = document.getElementById('CheckOut').value;

			let splitValuesCheckIn = getCheckInValue.split('-');
			let splitValuesCheckOut = getCheckOutValue.split('-');

			let containerArrivalDate = document.getElementById('arrivalDateInput');
			let containerDepartureDate = document.getElementById('departureDateInput');
			let arrival_month = months[splitValuesCheckIn[1]-1];
			let departure_month = months[splitValuesCheckOut[1]-1];
			containerArrivalDate.innerHTML = `${splitValuesCheckIn[2]} ${arrival_month} ${splitValuesCheckIn[0]}`;
			containerDepartureDate.innerHTML = `${splitValuesCheckOut[2]} ${departure_month} ${splitValuesCheckOut[0]}`;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
				bookingDates();
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
				bookingDates();
			}
		});

		bookingDates();

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		/* Add five elements to animate border */
		function createLines ( element , number ) {
			let borderAnimate = document.querySelectorAll(element);
			if(borderAnimate.length > 0){
				borderAnimate.forEach((e)=>{
					for (let i = 1 ; i <= number ; i++) {
						let elements = document.createElement('div');
						elements.classList.add('line-'+i);
						e.appendChild(elements);
					}
				})
			}
		}
		createLines('.js-header-border-animate-5', 5);
		createLines('.js-border-animate-5', 5);
		createLines('.js-border-animate-4', 4);

		/* Animate lines on Scroll */
		let doc = document.documentElement, top = 0;
		function linesAnimate ( element , classAdded, animStart ) {
			let linesContainer = document.querySelectorAll(element),
				halfHeight = document.documentElement.clientHeight / animStart;
			linesContainer.forEach((e)=>{
				let eachTop = e.getBoundingClientRect().top;
				$(window).bind('scroll', function () {
					top = ( (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0) ) + halfHeight;
					if(top > eachTop) {
						e.classList.add(classAdded);
					}
				});
			});
		}
		linesAnimate('.js-border-animate-5', 'js-line-animate', 2);
		linesAnimate('.js-border-animate-4', 'js-line-animate', 2);
		linesAnimate('.js-typed', 'js-typed-animation', 1.3);

		function animateText( element) {

			let lettersString = document.querySelectorAll(element);

			lettersString.forEach(eachElement=>{

				let elementContent = [...eachElement.textContent];
				let counter = 1;
				eachElement.innerHTML = "";

				elementContent.forEach( letter=>{

					let eachSpan = document.createElement('span');
					let animate = `animation-delay: ${counter*50}ms`;
					eachSpan.classList.add('letter');
					eachSpan.setAttribute('style', animate);
					eachSpan.innerHTML = letter;
					eachElement.appendChild(eachSpan);
					counter++;
				});
			});


		}
		animateText('.js-split-text');

		/*
		* this function make all the interaction for the map
		* on the homepage
		* */

		const mapHomeInteraction = function () {

			let getPinMap = [...document.querySelectorAll('.js-pin')] || [];
			let getInfoMap = [...document.querySelectorAll('.js-info')] || [];

            let countPin = 0;
            let lengthPins = getPinMap.length;

			 for( ; countPin < lengthPins; countPin++ ) {

                getPinMap[countPin].addEventListener('click', function (currentPinClicked) {

                    let currentPin = currentPinClicked.target;
                    let getDataPin = currentPin.getAttribute('data-pin');

                    let countInfo = 0;
                    let lengthInfo = getInfoMap.length;

                    outLoop: for( ; countInfo < lengthInfo; countInfo++ ){

                        let getDataInfo = getInfoMap[countInfo].getAttribute('data-info');

                        getInfoMap[countInfo].classList.remove('map-home-quad__active');
                        getPinMap[countInfo].classList.remove('pins-home__active');

                        if(getDataInfo !== getDataPin) continue outLoop;

                        getInfoMap[countInfo].classList.add('map-home-quad__active');

                    }
                    currentPin.classList.add('pins-home__active');
                    console.log('done');

                });
            }
        };

        mapHomeInteraction();

        /*
        * this function make all the interaction for the map
        * on the homepage
        * */



        const mainMenuInteraction = function () {

        	let getItemsMenu = [...document.querySelectorAll('#privary-navigation > li')] || [];
            let subMenu = [...document.querySelectorAll('.submenu')] || [];

            getItemsMenu.forEach(function (itemMenu) {

				itemMenu.addEventListener('mouseenter', function () {

                    getItemsMenu.forEach(function (otherItems) {

                        otherItems.classList.remove('on-hover');
                        otherItems.classList.remove('hover');

                    })

                    this.classList.remove('hover');
					this.classList.add('on-hover');
                })
            })

            subMenu.forEach(function (subMenuChild) {

                subMenuChild.addEventListener('mouseleave', function () {

                    this.parentNode.classList.remove('on-hover');
                })
            })


        }
        mainMenuInteraction();

		function languagesDropDown() {

			let getLanguageTarget = document.querySelector('.js-language-box');

			let languagesList = getLanguageTarget.nextElementSibling;

			getLanguageTarget.addEventListener('mouseenter', function () {
				// this.classList.add('active');
				this.childNodes[3].classList.add('active');
            })

            getLanguageTarget.addEventListener('mouseleave', function () {
                // this.classList.remove('active');
                this.childNodes[3].classList.remove('active');
            })

		}

        languagesDropDown();

        $('body#map-category #content, body#map #content').append('<a href="/ada-map" class="btn btn-ada"> accessible map</a>');


		const numbersInSliders = function(mainContainer, elementCreated, nameClassNewElement, dotsInContainer) {

			let getSliderImgBox = [...document.querySelectorAll(mainContainer)] || [];
			let elementNumbers = document.createElement(elementCreated);
			elementNumbers.setAttribute('class', nameClassNewElement);
			let getDotsElement = [...document.querySelectorAll(dotsInContainer)] || [];

			getSliderImgBox.forEach( function ( boxSliderImg ) {
				let getDotsBox = boxSliderImg.lastChild;
				let getWidthDotsBox = getDotsBox.offsetWidth;
				elementNumbers.style.left = `${getWidthDotsBox + 20+'px'}`;
				boxSliderImg.insertBefore( elementNumbers, getDotsBox.nextSibling );

				getDotsElement.forEach( everyDot => {

					let createSpan = document.createElement('span' );
					createSpan.textContent = everyDot.textContent;
					elementNumbers.appendChild( createSpan );
					elementNumbers.firstChild.setAttribute('class', 'active-number' );

					everyDot.addEventListener( 'click', function ( dot ) {

						let currentDot = dot.target;
						let getSpan = elementNumbers.childNodes;

						getSpan.forEach(function ( span ) {

							currentDot.textContent === span.textContent ?
							span.setAttribute('class', 'active-number' ) :
							span.removeAttribute('class');

						});

					});
				})
			});
		};

		numbersInSliders('.slider-img', 'div','slider-module__numbers-box', '.slider-img .slick-dots li');
		numbersInSliders('.events-quad-home-slider-info', 'div','slider-module__numbers-box', '.events-quad-home-slider-info .slick-dots li');

		$('.slider-img, .events-quad-home-slider-info').on('afterChange',function(){
			let currentSlide = $(this).slick('slickCurrentSlide');
			$('.slider-module__numbers-box span',this).removeClass('active-number');
			$('.slider-module__numbers-box span',this).eq(currentSlide).addClass('active-number');
		});

		/*
		* booking behavior
		* */

		const getBookBtn = document.querySelector('.js-booking-trigger');
		const getBookBox = document.querySelector('.js-booking-box');
		const getCloseBook = document.querySelector('.js-close-booking');

		getBookBtn.addEventListener('click', _ => {
			getBookBox.classList.add('booking-open');
		})

		getCloseBook.addEventListener('click', _ => {
			getBookBox.classList.remove('booking-open');
		})

		if( window.location.pathname != '/' ){
			setTimeout(function(){
				$('#content-popin').removeClass('hide-left-popin');
				$('.box-content-popin').addClass('open');
			},100)
		}


		
	// let hash = this.hash;

	// if (this.hash !== "") {
	//     event.preventDefault();
	//     hash
	//     $('html, body').animate({
	//         scrollTop: $(hash).offset().top
	//     }, 800, function() {
	//         window.location.hash = hash;
	//     });
	// }
	 

	 
		




		// $("a.rfp-form").click(function(event){
		//     if (this.hash !== "") {
		//     	event.preventDefault();
		//       	var hash = this.hash;
		//       	$('html, body').animate({
		//         	scrollTop: $(hash).offset().top
		//       	}, 800, function(){
		//         	window.location.hash = hash;
		//       	});
		//     } 
		// });

		/* avoid negative numbers */
		$('input[type="number"]').attr('min', '0');

	});

	$(window).on('load', function(){

	});

}());